import React, { useEffect } from "react";
import RenderCategories from "features/Category/category/components/Categeries";
import SortContext from "context/SortContext";
import { useLocation, useNavigate } from "react-router-dom";

const Categories = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { setSortOptions, setSelectedSortValue, setSearch, selectedSortValue, sortOptions } = React.useContext(SortContext);

  // When opened from CRM via window.open, React Router state is empty.
  // CRM encodes the required flow state as a base64 ?crmState= query param.
  // localStorage cannot be used — CRM and Vision run on different origins (ports).
  useEffect(() => {
    if (location.state?.innerChnages) return; // already has state, normal vision flow
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("crmState");
    if (!encoded) return;
    try {
      const crmState = JSON.parse(atob(encoded));
      navigate("/Category", { replace: true, state: crmState });
    } catch (_) {}
  }, []);

  useEffect(() => {
    setSortOptions([
      { id: 1, name: "Alphabetical Quote (A to Z)", sortBy: "alphabetical", order: "asc" },
      { id: 2, name: "Alphabetical Quote (Z to A)", sortBy: "alphabetical", order: "desc" },
      { id: 3, name: "Design Quantity (High to Low)", sortBy: "quantity", order: "desc" },
      { id: 4, name: "Design Quantity (Low to High)", sortBy: "quantity", order: "asc" },
    ]);

    return () => {
      setSortOptions([]);
      setSelectedSortValue(null);
      setSearch("");
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    setSearch(location?.state?.categorySearch || "");
  }, [location]);

  return <RenderCategories />;
};

export default Categories;
